// A new selection may intentionally contain duplicates. Retrying the current
// batch, however, must never upload its successful or already-confirmed entries.
export function buildUploadQueue(files, progress = {}) {
  return files.map((file, index) => ({ file, index, size: file.size || 0 }))
    .filter(({ index }) => {
      const entry = progress[index];
      return !entry || (entry.status === 'error' && !entry.imageId && !entry.needsProcessing);
    })
    .sort((a, b) => b.size - a.size);
}
export function uploadFailureEntry(error) {
  return {
    status: 'error', percent: 0,
    processingError: {
      category: error?.status === 415 ? 'corrupted_file' : 'system_error',
      message: error?.message || 'Upload failed. Please try again.',
      retryable: ![400, 403, 413, 415].includes(error?.status)
    }
  };
}

// Delayed XHR byte progress cannot replace confirmed server/processing state.
export function mergeTransferProgress(current, pending) {
  const next = { ...current };
  for (const [index, update] of Object.entries(pending)) {
    const entry = current[index];
    if (entry?.imageId || ['complete', 'processing', 'error'].includes(entry?.status)) continue;
    next[index] = { ...entry, ...update };
  }
  return next;
}
